import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div", ...rest }) => {
  const M = motion[as];
  return (
    <M
      {...rest}
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </M>
  );
};

export const MaskLines = ({ text = "", className = "", lineClass = () => "", delay = 0.15, onLoad = false }) => {
  const lines = String(text).split("\n");
  const anim = onLoad
    ? { initial: "hide", animate: "show" }
    : { initial: "hide", whileInView: "show", viewport: { once: true, amount: 0.1 } };
  return (
    <motion.span className={`block ${className}`} {...anim}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClass(i, lines.length)}`}
            variants={{ hide: { y: "105%" }, show: { y: "0%" } }}
            transition={{ duration: 1.05, delay: delay + i * 0.12, ease: EASE }}
          >
            {l}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const SectionLabel = ({ children, tone = "frost", index }) => (
  <div className="flex items-center gap-3 font-mono text-[11px] sm:text-xs uppercase tracking-[0.22em]">
    {index && <span className="text-slate-400">{index}</span>}
    <span className={`h-px w-8 ${tone === "heat" ? "bg-[#ff5500]" : "bg-[#4fc3f7]"}`} />
    <span className={tone === "heat" ? "text-[#ff8a4c]" : "text-[#7fd6fb]"}>{children}</span>
  </div>
);
